<template>
  <div class="honor" ref="honor">
    <h1>B端成绩</h1>
    <img :src="require('@/assets/homes/text3.png')" alt="">
  </div>
</template>

<script setup>
import { reactive,defineProps, watch, ref } from "vue";

const honor = ref('')

const props = defineProps({
    InitialIndex: String
})
watch(()=>props.InitialIndex,()=>{
    if(props.InitialIndex == '3'){
        honor.value.style.transform = 'translateX(0)';
        honor.value.style.opacity = '1';
    }
})
</script>

<style lang="less" scoped>
.honor {
  box-sizing: border-box;
  height: 100%;
  padding: 10px 10%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  transition: all 1.5s ease;
  transform: translateX(100%);
  opacity: 0;

  h1 {
    display: inline-block;
    box-sizing: border-box;
    padding: 0px 20px 10px 0;
    margin-right: 50%;
    border-bottom: 2px solid gray;
  }

  img{
    width: 100%;
  }
}
</style>
